import React, { useState } from "react";

const DocsUpload = (props) => {
  const [fields, setFields] = useState(props?.fields);

  return (
    <>
      <AppForm onSubmit={props.onDocsSubmit}>
        {fields?.map((field, i) => {
          return (
            <div
              className={`col-12 col-md-${field?.customcolspan || 4} col-xl-3`}
              key={i}
            >
              <AppInput
                labelClass={"focus-label"}
                controlClass="floating"
                {...field}
                labelpos="top"
                className={"form-focus " + (field?.className || "")}
              ></AppInput>
            </div>
          );
        })}
        <div className="nav_container">
          <button
            className="formdata-cancel-btn btn"
            onClick={(...args) => props.onHandleStep(...args, 3)}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary ms-3">
            Save & Submit
          </button>
        </div>
      </AppForm>
    </>
  );
};

export default constore(DocsUpload);
